/**
 * Страница новостей (лента). Сделан рефреш.
 */

import { useCallback, useRef } from 'react';
import { FeedWidget } from '@/features/feed/components/Feed';
import { useRouterNavigation } from '@/lib';
import { PullToRefresh } from '@/components';

export function FeedPage(): JSX.Element {
  const { toItemDetail, toUserProfile } = useRouterNavigation();

  const refetchRef = useRef<(() => Promise<unknown>) | null>(null);

  const handleRefreshReady = useCallback((refetch: () => Promise<unknown>) => {
    refetchRef.current = refetch;
  }, []);

  const handleRefresh = useCallback(async () => {
    await refetchRef.current?.();
  }, []);

  return (
    <PullToRefresh onRefresh={handleRefresh}>
      <div className="px-4 pt-4 flex-1 flex flex-col">
        <FeedWidget
          onItemClick={(wishlistId, itemId) => toItemDetail(wishlistId, itemId)}
          onUserClick={toUserProfile}
          onRefreshReady={handleRefreshReady}
        />
      </div>
    </PullToRefresh>
  );
}